import { ItemSubCategoryBase } from './base/item-sub-category-base';

export class ItemSubCategory extends ItemSubCategoryBase { }